import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { remoteStore } from '@/cloud/store';
import { mergeSummaryText, onLedgerEvent } from '@/cloud/sync';
import { useToast } from '../hooks/useToast';

/**
 * Says so when another device's changes land, whichever path merged them —
 * the watcher, a backup, or the pull before a booking — and when two devices
 * booked the same number. Renders nothing; it only subscribes.
 */
export function LedgerSyncNotices() {
  const toast = useToast();
  const navigate = useNavigate();
  useEffect(
    () =>
      onLedgerEvent((event) => {
        const provider = remoteStore()?.label ?? 'lagringen';
        if (event.type === 'merged') {
          const text = mergeSummaryText(event.summary);
          if (!text) return;
          const from = event.writtenBy?.deviceName ? ` (från ${event.writtenBy.deviceName})` : '';
          toast.show(`Hämtat från ${provider}: ${text}${from}.`, { tone: 'ok', key: 'ledger-merged' });
          return;
        }
        toast.show(event.message, {
          tone: 'danger',
          duration: 0,
          key: 'ledger-conflict',
          action: { label: 'Visa', onClick: () => navigate(remoteStore()?.id === 'koofr' ? '/mer/lagring/koofr' : '/mer/lagring/drive') },
        });
      }),
    [navigate, toast],
  );
  return null;
}
